namespace SorAraBul.Web.Modules {
    export namespace UserCreditPurchasePermissions {
        export const Buy = "UserCreditPurchase:Buy";
    }
}
